export default __webpack_public_path__ + "assets/models/a7a4db65f226a053baff02a799a8212e.glb";